import { AlertBannerState } from '../types';

export const initialAlertBannerState: AlertBannerState = {};
